import get from 'lodash/get';
import has from 'lodash/has';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import { generateDefaultData, normalizeValue } from './data-helpers';

export const HISTORY_CUTOFF_DATE = new Date('2024-02-21T00:00:00Z');
export const HISTORY_CUTOFF_LABEL = '02-21-2024';
export const REMOVED_TEMPLATE_FIELDS_MESSAGE =
    'No tracked field changes in this snapshot. One or more fields may have been removed from the current form, so their history cannot be displayed.';

export function historyMergeCustomizer(objValue, srcValue) {
    if (isArray(objValue) || isArray(srcValue)) {
        return srcValue;
    }
}

export function flattenTemplateFields(group = {}, parentPath = []) {
    return Object.entries(group).reduce((fields, [key, item]) => {
        if (typeof item === 'object' && item?.type === 'GROUP' && item?.properties) {
            return fields.concat(
                flattenTemplateFields(item.properties, [...parentPath.slice(0), key])
            );
        }
        const path = [...parentPath.slice(0), key].join('.');
        fields.push({
            key,
            path,
            displayKey: item.displayKey,
            templateItem: item,
        });
        return fields;
    }, []);
}

function isFieldChanged(currentItem, previousItem, path, templateItem) {
    if (isEmpty(previousItem)) {
        return normalizeValue(get(currentItem, path), templateItem) !== '-';
    }
    // If the current item has the path but the previous item does not, it is a new field.
    if (has(currentItem, path) && !has(previousItem, path)) {
        return true;
    }
    return (
        normalizeValue(get(currentItem, path), templateItem) !==
        normalizeValue(get(previousItem, path), templateItem)
    );
}

export function buildHistoryRecords(historyItems = [], template = {}) {
    const templateFields = flattenTemplateFields(template);

    return historyItems.map((historyItem, index) => {
        const currentHistoryItem = historyItem;
        const previousHistoryItem = historyItems[index + 1];
        const changedFields = templateFields.reduce(
            (changes, { key, path, displayKey, templateItem }) => {
                if (!isFieldChanged(currentHistoryItem, previousHistoryItem, path, templateItem)) {
                    return changes;
                }
                changes.push({
                    key,
                    path,
                    displayKey,
                    previousValue: normalizeValue(get(previousHistoryItem, path), templateItem),
                    currentValue: normalizeValue(get(currentHistoryItem, path), templateItem),
                });
                return changes;
            },
            []
        );
        const isCurrentRecord = historyItem.history_id === 0;
        const isInitialRecord = !historyItems[index + 1];
        const changedCount = changedFields.length;
        const updatedDate = new Date(historyItem.updated);
        const showHistoryCutoffFootnote = isInitialRecord && updatedDate < HISTORY_CUTOFF_DATE;

        return {
            historyItem,
            changedFields,
            isCurrentRecord,
            isInitialRecord,
            changedCount,
            showHistoryCutoffFootnote,
        };
    });
}
